'use client';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import React, { ButtonHTMLAttributes, FC } from 'react';

import BaseButton from '1_components/Buttons/BaseButton/BaseButton';
import useAudioRoutingStore from 'state/audioRoutingStore';
import { useHeaderStore } from 'state/headerStore';
import { trackAboutProject } from 'utils/gtagEvents';

import S from './InfoMenuButton.module.scss';

export interface InfoMenuButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {}

const InfoMenuButton: FC<InfoMenuButtonProps> = () => {
  const {
    toggleSideMenu,
    isReportButtonVisible,
    isSideMenuOpen,
    isBackButtonVisible,
    isInfoMenuButtonCompact,
  } = useHeaderStore();
  const path = usePathname();

  const setIsAudioPlaying = useAudioRoutingStore(s => s.setIsPlaying);

  return (
    <BaseButton
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={() => {
        toggleSideMenu();
        setIsAudioPlaying(false);
        if (!isSideMenuOpen) trackAboutProject();
        else setIsAudioPlaying(true);

        if (path === '/report') return;
      }}
      style={{
        padding:
          isSideMenuOpen ||
          isBackButtonVisible ||
          isReportButtonVisible ||
          isInfoMenuButtonCompact
            ? 10
            : '10px 24px',
      }}
    >
      {isSideMenuOpen ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: 'scale(1.5)' }}
        >
          <g filter="url(#filter0_d_1239_3523)">
            <path
              d="M20.0001 21.4143L24.293 25.7072L25.7072 24.293L21.4143 20.0001L25.7072 15.7072L24.293 14.293L20.0001 18.5859L15.7072 14.293L14.293 15.7072L18.5859 20.0001L14.293 24.293L15.7072 25.7072L20.0001 21.4143Z"
              fill="#F2F2EE"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_1239_3523"
              x="-1.70703"
              y="-1.70703"
              width="43.4141"
              height="43.4141"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="8" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1239_3523"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1239_3523"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      ) : (
        <div
          style={{
            display: 'flex',
            gap:
              !isReportButtonVisible &&
              !isBackButtonVisible &&
              !isInfoMenuButtonCompact
                ? 12
                : 0,
            alignItems: 'center',
            pointerEvents: 'none',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0003 3.83341C7.49699 3.83341 3.83366 7.49675 3.83366 12.0001C3.83366 16.5034 7.49699 20.1667 12.0003 20.1667C16.5037 20.1667 20.167 16.5034 20.167 12.0001C20.167 7.49675 16.5037 3.83341 12.0003 3.83341ZM12.0003 21.3334C6.85416 21.3334 2.66699 17.1462 2.66699 12.0001C2.66699 6.85392 6.85416 2.66675 12.0003 2.66675C17.1465 2.66675 21.3337 6.85392 21.3337 12.0001C21.3337 17.1462 17.1465 21.3334 12.0003 21.3334ZM11.417 17.8334H12.5837V10.8334H11.417V17.8334ZM11.417 8.50008H12.5837V6.16675H11.417V8.50008Z"
              fill="white"
            />
          </svg>

          {!isReportButtonVisible &&
            !isBackButtonVisible &&
            !isInfoMenuButtonCompact && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className={S.text_wrapper}
              >
                About the project
              </motion.div>
            )}
        </div>
      )}
    </BaseButton>
  );
};
export default InfoMenuButton;
